import { useState } from 'react';
import { IFarmResource } from '../../../entities/farms.entities';
import { TBusinessType } from '../../../entities/general.entities';
import MusselBulkHarvestModal from './MusselBulkHarvestModal';
import OysterBulkHarvestModal from './OysterBulkHarvestModal';
import { AreaClosedConfirmModal } from '../../CommonViews';

interface Props {
  type: TBusinessType;
  visible: boolean;
  title?: string;
  farm?: IFarmResource;
  data?: any;
  onCancel: () => void;
  onConfirm: (data: any) => void;
  overConfirm?: (data: any) => void;
  onlyView?: boolean;
  warningMessage?: string;
  confirmID?: number;
}

const BulkHarvestModal = ({
  type,
  visible,
  title,
  farm,
  data,
  onCancel,
  onConfirm,
  overConfirm,
  onlyView,
  warningMessage,
  confirmID,
}: Props) => {
  const [isConfirmed, setIsConfirmed] = useState(false);

  if (!onlyView && !isConfirmed) {
    return (
      <AreaClosedConfirmModal
        farmId={farm?.id}
        onCancel={onCancel}
        onConfirm={() => setIsConfirmed(true)}
      />
    );
  }
  return (
    <>
      {type === 'MUSSEL' ? (
        <MusselBulkHarvestModal
          visible={visible}
          title={title}
          farm={farm}
          data={data}
          onCancel={onCancel}
          onConfirm={onConfirm}
          overConfirm={overConfirm}
          onlyView={onlyView}
          confirmID={confirmID}
          warningMessage={warningMessage}
        />
      ) : type === 'OYSTER' ? (
        <OysterBulkHarvestModal
          visible={visible}
          title={title}
          farm={farm}
          data={data}
          onCancel={onCancel}
          onConfirm={onConfirm}
          overConfirm={overConfirm}
          onlyView={onlyView}
          confirmID={confirmID}
          warningMessage={warningMessage}
        />
      ) : (
        <></>
      )}
    </>
  );
};

export default BulkHarvestModal;
